import React, { useEffect } from "react";
import SEO from "../Components/Seo";
import Header from "../Components/Nav/Header";
import Footer from "../Components/Nav/Footer";
import Contact from "../Components/Main/Contact";
import team1 from "../Assets/Images/team1.png";
import banner from "../Assets/Images/About-us-bg2.png";
import Image from "../Components/Image";
const AboutUs = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <div className="bg-[#FFF]">
      <SEO
        title={""}
        description={""}
        name={"Greengate Pharmaceuticals"}
        type={"article"}
      />
      <Header />

      <div className="w-[90%] mt-10 mb-20 mx-auto">
        <h3 className="font-[600]  text-[56px] sm:text-[60px] text-[#000]  sm:leading-[74px] ">
          About us
        </h3>
        <h4 className="font-[400] max-w-[90%] sm:max-w-[70%] text-[18px] sm:text-[22px] mb-8 sm:mt-4 sm:mb-16 text-[#000] sm:leading-[26px] ">
          Empowering Health, Enhancing Lives. Experience Excellence with
          Greengate Pharmaceuticals
        </h4>

        <div className="w-full bg-[rgba(111,108,108,0.4)]">
          <img src={banner} className="object-cover w-full max-h-[50%]" />
        </div>

        <div className="flex justify-between gap-4 flex-wrap mt-16">
          <h3 className="font-[500] text-[30px] sm:text-[40px] text-[#000]  sm:leading-[48px] ">
            Background
          </h3>
          <div className="sm:max-w-[895px]">
            <h4 className="font-[400]  text-[18px] sm:text-[24px] mb-4 text-[#000] sm:leading-[44px] ">
              Greengate Pharmaceuticals Ltd 12 ipaye close bode Thomas surulere
              Lagos and Incorporated 4th  day of May 2011.
            </h4>
            <h4 className="font-[400] text-[18px] sm:text-[24px] mb-4 text-[#000] sm:leading-[44px] ">
              For over a decade, Greengate Pharmaceutical Ltd has partnered with
              a wide array of customers and consultants in numerous fields and
              specializations in supplies and projects such as the Federal
              immigration service hospital, in 2011, the University of Maiduguri
              supply of scientific and laboratory equipment in 2018, IMO state
              Teaching Hospital 2019. Greengate Pharmaceutical Ltd is deeply
              passionate about adding value to Nigeria and will continue to
              strive to positively impact the country’s business environment and
              society at large.
            </h4>
            <h4 className="font-[400] text-[18px] sm:text-[24px] mb-4 text-[#000] sm:leading-[44px] ">
              We pride ourselves “In quality healthcare and wellness products”.
              We specialize in manufacturing, dispensing, and selling
              pharmaceuticals drugs, and quality supplements.
            </h4>
          </div>
        </div>
        <div className="flex justify-between gap-4 flex-wrap mt-16">
          <h3 className="font-[500] text-[30px] sm:text-[40px] text-[#000]  sm:leading-[48px] ">
            Business
          </h3>
          <div className="sm:max-w-[895px]">
            <h4 className="font-[400]  text-[18px] sm:text-[24px] mb-4 text-[#000] sm:leading-[44px] ">
              OUR VISION: <br />
              To be a major brand distributing and marketing quality healthcare
              and wellness products and services that satisfy our customer's
              daily needs.
            </h4>
            <h4 className="font-[400] text-[18px] sm:text-[24px] mb-4 text-[#000] sm:leading-[44px] ">
              MISSION: <br />
              To be a global brand ensuring quality and providing healthcare
              services but spreading beyond Nigeria's borders, expanding to West
              Africa, the Continent and beyond. Our diverse clients from
              different professional specializations benefit from our wide array
              of products needed in the health sector.
            </h4>
            <h4 className="font-[400] text-[18px] sm:text-[24px] mb-4 text-[#000] sm:leading-[44px] ">
              CORE VALUES: <br />
              Our core values are the driving force behind who we are and what
              we do.. These core values inspire us to always put first the needs
              and well-being of the people and communities we serve.
            </h4>{" "}
          </div>
        </div>
        <div className=" mt-16">
          <h3 className="font-[500] mb-5 text-[30px] sm:text-[40px] text-[#000]  sm:leading-[48px] ">
            Team
          </h3>
          <div className="flex w-full gap-x-[5%] gap-y-5 flex-wrap">
            <img
              src={team1}
              className="w-full sm:max-w-[538px] object-contain object-top max-h-[444px]"
              alt=""
            />
            <div className="max-w-[640px]">
              <h4 className="font-[400] text-[18px] sm:text-[24px] mb-2 text-[#000] sm:leading-[44px] ">
                Mr. George Okoro
              </h4>
              <h4 className="font-[400] text-[18px] sm:text-[24px] mb-2 text-[#000] sm:leading-[44px] ">
                (Chief Executive Officer) Greengate Pharmaceuticals.
              </h4>
              <h4 className="font-[400] text-[18px] sm:text-[24px] mb-4 text-[#000] sm:leading-[44px] ">
                Mr. George Okoro, hailing from the vibrant Orlu Local Government
                Area of Imo State, is a seasoned leader in the pharmaceutical
                industry with a rich background spanning nearly two decades.
                Born in Lagos, George demonstrated an early passion for
                leadership and management, culminating in a Bachelor of Science
                in Business Administration with a focus on Leadership and
                Management.
              </h4>
              <h4 className="font-[400] text-[18px] sm:text-[24px] mb-4 text-[#000] sm:leading-[44px] ">
                Since embarking on his professional journey in the
                pharmaceutical field in 2005, George has consistently driven
                innovation and quality in healthcare. His dedication to
                advancing the sector led him to establish Greengate
                Pharmaceuticals in 2011, a company committed to providing
                accessible, high-quality pharmaceuticals to communities across
                Nigeria and beyond.
              </h4>
              <h4 className="font-[400] text-[18px] sm:text-[24px] mb-4 text-[#000] sm:leading-[44px] ">
                Under George's visionary leadership, Greengate Pharmaceuticals
                has flourished, earning a reputation for reliability, integrity,
                and excellence. His strategic insights and unwavering commitment
                to advancing public health have positioned the company at the
                forefront of the industry.
              </h4>
              <h4 className="font-[400] text-[18px] sm:text-[24px] mb-4 text-[#000] sm:leading-[44px] ">
                Outside of his professional life, Mr. Okoro is an avid badminton
                enthusiast, enjoying the sport during his leisure time. He
                values the importance of balance in life and believes that
                engaging in physical activities fosters both mental clarity and
                personal well-being.
              </h4>
              <h4 className="font-[400] text-[18px] sm:text-[24px] mb-4 text-[#000] sm:leading-[44px] ">
                With a passion for making a difference in the pharmaceutical
                landscape, Mr. George Okoro continues to inspire his team and
                stakeholders, driving Greengate Pharmaceuticals toward a
                healthier, more vibrant future.
              </h4>
            </div>
          </div>
        </div>
      </div>
      <Contact />
      <Footer />
    </div>
  );
};

export default AboutUs;
